import Vue from 'vue'
// import { ImagePreview } from 'vant'

// 创建指令
Vue.directive('image-preview-mobile', {
  inserted(el) {
    console.log('Mobile directive inserted')
    processImages(el)
  },
  update(el) {
    console.log('Mobile directive update')
    processImages(el)
  }
})

// 处理图片的函数
function processImages(el) {
  console.log('Processing images')
  // 获取所有图片
  const images = el.getElementsByTagName('img')
  console.log('Found images:', images.length)

  // 为每个图片添加点击事件
  Array.from(images).forEach((img) => {
    // 如果图片已经被处理过，则跳过
    if (img.hasAttribute('data-preview-initialized')) return

    // 标记图片已处理
    img.setAttribute('data-preview-initialized', 'true')

    // 点击处理函数
    const handleClick = (e) => {
      e.preventDefault()
      e.stopPropagation()

      // 创建预览层
      const previewOverlay = document.createElement('div')
      previewOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2000;
        background-color: rgba(0, 0, 0, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        touch-action: none;
      `

      // 创建预览图片容器
      const previewContainer = document.createElement('div')
      previewContainer.style.cssText = `
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      `

      // 创建预览图片
      const previewImage = document.createElement('img')
      previewImage.src = img.src
      previewImage.style.cssText = `
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        transform-origin: center;
        will-change: transform;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
      `

      // 缩放相关变量
      let scale = 1
      let lastDistance = 0
      let isDragging = false
      let startX = 0
      let startY = 0
      let translateX = 0
      let translateY = 0
      let lastTranslateX = 0
      let lastTranslateY = 0
      let touchStartTime = 0
      let touchStartX = 0
      let touchStartY = 0
      let lastTap = 0

      // 处理双指缩放
      previewContainer.addEventListener('touchstart', (e) => {
        if (e.touches.length === 2) {
          e.preventDefault()
          lastDistance = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          )
        } else if (e.touches.length === 1) {
          isDragging = true
          startX = e.touches[0].pageX - lastTranslateX
          startY = e.touches[0].pageY - lastTranslateY
          touchStartTime = Date.now()
          touchStartX = e.touches[0].pageX
          touchStartY = e.touches[0].pageY
        }
      }, { passive: false })

      previewContainer.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2) {
          e.preventDefault()
          const distance = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          )
          const newScale = scale * (distance / lastDistance)
          scale = Math.min(Math.max(newScale, 0.5), 3)
          lastDistance = distance
          requestAnimationFrame(() => {
            previewImage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`
          })
        } else if (e.touches.length === 1 && isDragging) {
          e.preventDefault()
          translateX = e.touches[0].pageX - startX
          translateY = e.touches[0].pageY - startY
          requestAnimationFrame(() => {
            previewImage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`
          })
        }
      }, { passive: false })

      previewContainer.addEventListener('touchend', (e) => {
        const touchEndTime = Date.now()
        const touchEndX = e.changedTouches[0].pageX
        const touchEndY = e.changedTouches[0].pageY

        // 判断是否为点击事件（时间短且移动距离小）
        if (touchEndTime - touchStartTime < 300 &&
          Math.abs(touchEndX - touchStartX) < 10 &&
          Math.abs(touchEndY - touchStartY) < 10) {
          // 双击重置
          if (touchEndTime - lastTap < 300) {
            scale = 1
            translateX = 0
            translateY = 0
            lastTranslateX = 0
            lastTranslateY = 0
            requestAnimationFrame(() => {
              previewImage.style.transform = `translate(0, 0) scale(1)`
            })
          }
          lastTap = touchEndTime
        }

        isDragging = false
        lastTranslateX = translateX
        lastTranslateY = translateY
      }, { passive: true })

      // 点击背景关闭预览
      const closePreview = () => {
        if (document.body.contains(previewOverlay)) {
          document.body.removeChild(previewOverlay)
        }
      }

      // 监听遮罩层触摸事件
      previewOverlay.addEventListener('touchstart', (e) => {
        if (e.target === previewOverlay) {
          touchStartTime = Date.now()
          touchStartX = e.touches[0].pageX
          touchStartY = e.touches[0].pageY
        }
      }, { passive: true })

      previewOverlay.addEventListener('touchend', (e) => {
        if (e.target === previewOverlay) {
          const touchEndTime = Date.now()
          const touchEndX = e.changedTouches[0].pageX
          const touchEndY = e.changedTouches[0].pageY

          // 判断是否为点击事件（时间短且移动距离小）
          if (touchEndTime - touchStartTime < 300 &&
            Math.abs(touchEndX - touchStartX) < 10 &&
            Math.abs(touchEndY - touchStartY) < 10) {
            closePreview()
          }
        }
      }, { passive: true })

      // 添加关闭按钮
      const closeButton = document.createElement('div')
      closeButton.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2001;
        cursor: pointer;
      `
      closeButton.innerHTML = `
        <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      `
      closeButton.addEventListener('click', closePreview)

      // 添加到页面
      previewContainer.appendChild(previewImage)
      previewOverlay.appendChild(previewContainer)
      previewOverlay.appendChild(closeButton)
      document.body.appendChild(previewOverlay)
    }

    // 添加点击事件
    img.addEventListener('click', handleClick)
  })
}

// 添加全局样式
const style = document.createElement('style')
style.textContent = `
  .van-image-preview {
    display: block;
    width: 100%;
    height: auto;
    margin: 10px 0;
    cursor: pointer;
  }
`
document.head.appendChild(style) 